import { addDays } from 'date-fns';

import { internationalDateFormat } from 'src/helper/helper';
import type { RequiredDateRange } from 'src/components/myFollowUp/MyFollowUpPage/Sidebar/helper';
import { defaultDateRange } from 'src/components/myFollowUp/MyFollowUpPage/Sidebar/helper';

export const dateRangeToReadableString = (
  dateRange: RequiredDateRange,
): string =>
  `${internationalDateFormat(dateRange.startDate)} - ${internationalDateFormat(dateRange.endDate)}`;

export const calculateInitialDateRange = (
  initialDateRange?: RequiredDateRange,
  minDate?: Date,
) => {
  // Create a copy by spreading to prevent mutating read only vars
  const dateRange = { ...(initialDateRange ?? defaultDateRange) };
  if (!minDate) return dateRange;

  if (dateRange.startDate < minDate) {
    dateRange.startDate = minDate;
  }
  if (dateRange.endDate < minDate) {
    dateRange.endDate = addDays(minDate, 1);
  }
  return dateRange;
};
